module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.3f58260f.jpg";